import { GetterTree, Getter } from 'vuex'

import { IJobStore } from '@/features/job/store'
import {
  GET_JOB_ID,
  GET_SAMPLE,
  GET_STATUS,
  GET_PROCESSING_ERRORS,
  GET_JOB_LIST,
  GET_JOB_ERRORS_BY_PROJECT,
  GET_PROJECTS
} from '@/system/store/getter-types'

const getJobId: Getter<IJobStore, any> = (state: IJobStore) => state.job.jobId

const getSample: Getter<IJobStore, any> = (state: IJobStore) => state.job.meta.sample

const getStatus: Getter<IJobStore, any> = (state: IJobStore) => state.job.status

const getProcessingErrors: Getter<IJobStore, any> = (state: IJobStore) => state.job.meta.processingErrors

const getJobList: Getter<IJobStore, any> = (state: IJobStore) => state.list

const getJobErrorsGroupedByProject: Getter<IJobStore, any> = (state: IJobStore, { [GET_PROJECTS]: projects }: any) => {
  const projectsMatrix = projects.reduce((acc: any, { id, nameByCustomer }: any) => ({
    ...acc,
    [id]: nameByCustomer
  }), {})

  const errorsGroupedByProject = state?.selectedJob?.meta?.processingErrors.reduce((acc: any, e: any) => ({
    ...acc,
    [projectsMatrix[e.project] || [e.project]]: [].concat(acc[projectsMatrix[e.project] || [e.project]] || [], e)
  }), {})
  return errorsGroupedByProject
}

const getters: GetterTree<IJobStore, any> = {
  [GET_JOB_ID]: getJobId,
  [GET_SAMPLE]: getSample,
  [GET_STATUS]: getStatus,
  [GET_PROCESSING_ERRORS]: getProcessingErrors,
  [GET_JOB_LIST]: getJobList,
  [GET_JOB_ERRORS_BY_PROJECT]: getJobErrorsGroupedByProject
}

export default getters
